import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonToolbar } from 'reactstrap';
import SmartButton from '../../../shared/components/SmartButton';
import DynamicNavigationTabs from '../../../shared/components/DynamicNavigationTabs';
import SmartTable from '../../../shared/components/material-table';
import ReportCardCustomHeaderStudent from './reportCardStudent/ReportCardCustomHeaderStudent';
import ColumnsReportCardOrderStudent from './reportCardStudent/ColumnsReportCardOrderStudent';
import ReportCardCustomHeaderSubject from './reportCardSubject/ReportCardCustomHeaderSubject';
import ColumnsReportCardOrderSubject from './reportCardSubject/ColumnsReportCardOrderSubject';
import WrapperCardInfo from './WrapperCardInfo';
import MissingSubjects from './MissingSubjects';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import { generateReport, openReport } from '../../../shared/utils/smartutils';
import {
  REPORT_PARAMETERS,
  REPORT_TYPES,
  REPORT_CARD_STATUS,
  STATUS_CREATED,
} from '../../../shared/utils/constants';

const ReportCardView = (props) => {
  const {
    t,
    backHandler,
    toggleStudentReportCardForm,
    toggleRemoveReportCardForm,
    toggleReportCardRelease,
    disciplinesLacking,
    selectedSchoolClass,
    reportCardWrapper,
    changeReportCardWrapper,
    closure,
    updateDisciplinesLackingOnBlur,
    loadReportCardBySchoolClass,
    setEditable,
    editable,
    toggleEditable,
    changeDisciplinesLacking,
    dispatch,
    saveReportCard,
  } = props;

  const visualizationTabs = {
    VIEW_BY_STUDENT: 1,
    VIEW_BY_SUBJECT: 2,
  };

  const [showEditable, setShowEditable] = useState(false);
  const [pendToFinished, setPendToFinished] = useState(false);
  const [selectedTab, setSelectedTab] = useState(
    visualizationTabs.VIEW_BY_STUDENT
  );

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const updateSubjectData = (
    studentId,
    field,
    value,
    index,
    updatedWrapper
  ) => {
    const updatedData = [...updatedWrapper.subjects];
    const student = updatedData[index].data.find(
      (item) => item.id === studentId
    );
    const studentIndex = updatedData[index].data.findIndex(
      (item) => item.id === studentId
    );
    student[field] = value;
    updatedData[index].data[studentIndex] = student;
    const reassignUpdatedWrapper = updatedWrapper;
    reassignUpdatedWrapper.subjects = updatedData;
    changeReportCardWrapper(reassignUpdatedWrapper);
  };

  const updateStudentData = (
    subjectId,
    field,
    value,
    index,
    updatedWrapper
  ) => {
    const updatedData = [...updatedWrapper.students];
    const subject = updatedData[index].data.find(
      (item) => item.id === subjectId
    );
    const subjectIndex = updatedData[index].data.findIndex(
      (item) => item.id === subjectId
    );
    subject[field] = value;
    updatedData[index].data[subjectIndex] = subject;
    const reassignUpdatedWrapper = updatedWrapper;
    reassignUpdatedWrapper.students = updatedData;
    changeReportCardWrapper(reassignUpdatedWrapper);
  };

  const onchangeInputStudentData = (field, rowData, value, index) => {
    const updatedRow = { ...rowData };
    updatedRow.data[index][field] = value;
    const updatedData = [...reportCardWrapper.students];
    updatedData[rowData.tableData.id] = updatedRow;
    const updatedWrapper = { ...reportCardWrapper };
    updatedWrapper.students = updatedData;
    updateSubjectData(rowData.id, field, value, index, updatedWrapper);
  };

  const onchangeInputSubjectData = (field, rowData, value, index) => {
    const updatedRow = { ...rowData };
    updatedRow.data[index][field] = value;
    const updatedData = [...reportCardWrapper.subjects];
    updatedData[rowData.tableData.id] = updatedRow;
    const updatedWrapper = { ...reportCardWrapper };
    updatedWrapper.subjects = updatedData;
    updateStudentData(rowData.id, field, value, index, updatedWrapper);
  };

  const getColorFrequency = (frequency, minFrequency) => {
    return frequency >= minFrequency ? 'high-frequency' : 'low-frequency';
  };

  const getColorAverage = (average, minAverage) => {
    return average >= minAverage ? 'high-score' : 'low-score';
  };

  const generateSchoolReport = () => {
    showLoading();
    const formData = new FormData();
    const reportIds = reportCardWrapper.students.map(
      (student) => student.reportId
    );

    formData.append(
      REPORT_PARAMETERS.REPORTTYPE,
      selectedTab.toString() === visualizationTabs.VIEW_BY_STUDENT.toString()
        ? REPORT_TYPES.RELA_SCHOOLREPORT_STUDENT
        : REPORT_TYPES.RELA_SCHOOLREPORT_SUBJECT
    );
    formData.append(REPORT_PARAMETERS.pCO00TURM, selectedSchoolClass.id);
    formData.append(REPORT_PARAMETERS.pSCHOOLREPORTIDS, reportIds);
    generateReport(formData)
      .then(async (res) => {
        openReport(res.data);
        hideLoading();
      })
      .catch((e) => {
        hideLoading();
        console.error(e);
      });
  };

  const cellStyle = {
    borderRight: '1px solid white',
    fontSize: '13px',
    padding: '8px',
    maxWidth: '80px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  };

  const getReportCardWrapperStudentsLength = () => {
    return reportCardWrapper.students.length;
  };

  const getDisciplinesLackingLength = () => disciplinesLacking.length;

  const isEqualsReportCardStatus = (status) => {
    return selectedSchoolClass && selectedSchoolClass.status === status;
  };

  const isManualCycleRelease = () => {
    return selectedSchoolClass && !selectedSchoolClass.automaticCycleRelease;
  };

  const isDiffersReportCardStatus = (status) => {
    return selectedSchoolClass && selectedSchoolClass.status !== status;
  };

  const isReleaseReportCard = () => {
    return (
      isEqualsReportCardStatus(REPORT_CARD_STATUS.FINISHED) ||
      (pendToFinished && !editable)
    );
  };

  const showWrapperCardInfoManuallyRelease = () => {
    return (
      isManualCycleRelease() &&
      Boolean(showEditable && !pendToFinished && !getDisciplinesLackingLength())
    );
  };

  const showCardDisciplinesLacking = () => {
    return (
      (isEqualsReportCardStatus(REPORT_CARD_STATUS.PARTIAL) &&
        getDisciplinesLackingLength()) ||
      getDisciplinesLackingLength()
    );
  };

  const showManuallyReleaseButton = () => {
    return (
      isManualCycleRelease() &&
      isDiffersReportCardStatus(REPORT_CARD_STATUS.RELEASED) &&
      !!getReportCardWrapperStudentsLength()
    );
  };

  const showWrapperCardInfoCardRelease = () => {
    return (
      isEqualsReportCardStatus(REPORT_CARD_STATUS.FINISHED) ||
      isEqualsReportCardStatus(REPORT_CARD_STATUS.RELEASED) ||
      (isDiffersReportCardStatus(REPORT_CARD_STATUS.FINISHED) && pendToFinished)
    );
  };

  const getMessageWrapperCardInfoCardRelease = () => {
    return isEqualsReportCardStatus(REPORT_CARD_STATUS.RELEASED)
      ? t('general.report-card-released')
      : t('general.report-card-ready-release');
  };

  useEffect(() => {
    if (
      (isEqualsReportCardStatus(REPORT_CARD_STATUS.PENDING) ||
        isEqualsReportCardStatus(REPORT_CARD_STATUS.PARTIAL)) &&
      !getDisciplinesLackingLength() &&
      getReportCardWrapperStudentsLength()
    ) {
      setPendToFinished(true);
    }
  }, [disciplinesLacking]);

  useEffect(() => {
    if (selectedSchoolClass && selectedSchoolClass.status) {
      if (selectedSchoolClass.status === REPORT_CARD_STATUS.PENDING) {
        changeReportCardWrapper({ students: [], subjects: [] });
        setShowEditable(true);
        setPendToFinished(false);
        changeDisciplinesLacking([]);
      } else {
        setShowEditable(false);
        loadReportCardBySchoolClass(selectedSchoolClass);
      }
    }
  }, [selectedSchoolClass]);

  return (
    <div className="grid-container">
      <div className="form__form-group flex-1">
        <DynamicNavigationTabs callBackForActiveTabUpdate={setSelectedTab}>
          <div title={t('general.students')}>
            <SmartTable
              customTableHeader={ReportCardCustomHeaderStudent}
              data={reportCardWrapper.students}
              columns={ColumnsReportCardOrderStudent(
                t,
                reportCardWrapper.students,
                editable,
                onchangeInputStudentData,
                closure.course,
                getColorFrequency,
                getColorAverage,
                updateDisciplinesLackingOnBlur
              )}
              toolbar={false}
              paging={false}
              fixedFirstColumn
              rowStyle={(rowData, i) => ({
                backgroundColor: i % 2 === 0 ? '#FFF' : '#E7E7ED',
              })}
              cellStyle={cellStyle}
            />
          </div>
          <div className="json-report-card" title={t('general.subjects')}>
            <SmartTable
              customTableHeader={ReportCardCustomHeaderSubject}
              data={reportCardWrapper.subjects}
              columns={ColumnsReportCardOrderSubject(
                t,
                reportCardWrapper.subjects,
                editable,
                onchangeInputSubjectData,
                closure.course,
                getColorFrequency,
                getColorAverage,
                updateDisciplinesLackingOnBlur
              )}
              toolbar={false}
              paging={false}
              fixedFirstColumn
              rowStyle={(rowData, i) => ({
                backgroundColor: i % 2 === 0 ? '#FFF' : '#E7E7ED',
              })}
              cellStyle={cellStyle}
            />
          </div>
        </DynamicNavigationTabs>
      </div>
      <div className="form__form-group d-flex flex-1 justify-content-end flex-column">
        {showWrapperCardInfoCardRelease() && (
          <WrapperCardInfo
            title={getMessageWrapperCardInfoCardRelease()}
            color="success"
          />
        )}
        {showWrapperCardInfoManuallyRelease() && (
          <WrapperCardInfo
            title={
              <span>
                {t('general.no-information-registered')}
                <button
                  className="anchor-button"
                  type="button"
                  onClick={() => toggleEditable()}
                >
                  {t('general.launch-manually')}
                </button>
              </span>
            }
            color="danger"
          />
        )}
        {showCardDisciplinesLacking() ? (
          <MissingSubjects subjects={disciplinesLacking} />
        ) : null}
        <ButtonToolbar className="justify-content-between">
          <div className="d-flex">
            <SmartButton
              color="primary"
              label={t('general.back')}
              onClick={backHandler}
            />
            {showManuallyReleaseButton() && (
              <SmartButton
                label={
                  editable
                    ? t('general.closing-edition')
                    : t('general.edit-again')
                }
                color="warning"
                onClick={() => setEditable(!editable)}
              />
            )}
            {showManuallyReleaseButton() && (
              <SmartButton
                label={t('general.save')}
                color="outline-success"
                disabled={editable}
                onClick={() => saveReportCard(STATUS_CREATED)}
              />
            )}
            {isReleaseReportCard() && (
              <SmartButton
                label={t('general.release-report-card')}
                color="success"
                disabled={editable}
                onClick={() => toggleReportCardRelease()}
              />
            )}
            {isEqualsReportCardStatus(REPORT_CARD_STATUS.RELEASED) && (
              <div className="mt-2">
                <span className="font-weight-bold mr-1">
                  {t('general.released-colon')}
                </span>
                <span>{selectedSchoolClass.releaseDateWithHourPtBr}</span>
              </div>
            )}
          </div>
          {isEqualsReportCardStatus(REPORT_CARD_STATUS.RELEASED) ? (
            <div className="d-flex">
              <SmartButton
                color="danger"
                label={t('general.delete')}
                onClick={() =>
                  toggleRemoveReportCardForm(
                    selectedSchoolClass,
                    reportCardWrapper.students
                  )
                }
              />
              <SmartButton
                color="warning"
                label={t('general.student-report-card')}
                onClick={() => toggleStudentReportCardForm(selectedSchoolClass)}
              />
              <SmartButton
                label={t('general.print')}
                color="primary"
                onClick={() => generateSchoolReport()}
              />
            </div>
          ) : null}
        </ButtonToolbar>
      </div>
    </div>
  );
};

ReportCardView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  toggleStudentReportCardForm: PropTypes.func.isRequired,
  toggleRemoveReportCardForm: PropTypes.func.isRequired,
  toggleReportCardRelease: PropTypes.func.isRequired,
  disciplinesLacking: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ).isRequired,
  selectedSchoolClass: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    status: PropTypes.string,
    releaseDateWithHourPtBr: PropTypes.string,
    automaticCycleRelease: PropTypes.bool,
  }).isRequired,
  reportCardWrapper: PropTypes.shape({
    students: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
    subjects: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  }).isRequired,
  changeReportCardWrapper: PropTypes.func.isRequired,
  closure: PropTypes.shape(PropTypes.shape).isRequired,
  updateDisciplinesLackingOnBlur: PropTypes.func.isRequired,
  loadReportCardBySchoolClass: PropTypes.func.isRequired,
  toggleEditable: PropTypes.func.isRequired,
  setEditable: PropTypes.func.isRequired,
  changeDisciplinesLacking: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  saveReportCard: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ReportCardView)
);
